function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Location Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Location Icon",
    d: "M8 8a2.667 2.667 0 1 0-2.667-2.667A2.667 2.667 0 0 0 8 8zm0-4a1.333 1.333 0 1 1-1.333 1.333A1.333 1.333 0 0 1 8 4zm5.773 2.1-.479-.159a5.328 5.328 0 1 0-10.57.116 3.363 3.363 0 0 0-1.7.867A3.3 3.3 0 0 0 0 9.333v2.717a3.342 3.342 0 0 0 2.4 3.2l1.913.6a3.321 3.321 0 0 0 .993.15 3.384 3.384 0 0 0 .9-.124l3.853-1.14a1.991 1.991 0 0 1 1.049 0l1.591.533A2.667 2.667 0 0 0 16 12.681V9.248A3.343 3.343 0 0 0 13.773 6.1zm-8.6-3.6a4.006 4.006 0 0 1 5.663 5.667l-2.369 2.3a.661.661 0 0 1-.926 0L5.172 8.185a4.027 4.027 0 0 1 0-5.677zm9.495 10.173a1.327 1.327 0 0 1-.509 1.048 1.313 1.313 0 0 1-1.084.263l-1.563-.525a3.349 3.349 0 0 0-1.812-.003l-3.857 1.139a2 2 0 0 1-1.129-.019l-1.929-.6a2.009 2.009 0 0 1-1.452-1.926V9.333a1.976 1.976 0 0 1 .613-1.442 2.016 2.016 0 0 1 1.113-.537 5.347 5.347 0 0 0 1.177 1.779l2.378 2.3a1.989 1.989 0 0 0 2.783 0l2.375-2.309a5.308 5.308 0 0 0 1.209-1.881l.358.119a2 2 0 0 1 1.328 1.883z",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedLocation);
export default __webpack_public_path__ + "static/media/detailed-location.2d91c4b68496035f100ca0a262634098.svg";
export { ForwardRef as ReactComponent };